import * as Immutable from 'immutable';
import { IUserAddressStore } from '../_stores/UserAddressesStore';
import { AccountAction, AccountActionType } from '../_actions/UserAccountActions';
import { AjaxActionStart, AjaxActionEnd, AjaxActionStartType, AjaxActionEndType } from '../../Common/_actions/AjaxAction';

const UserAddressesReducer = (store:Immutable.OrderedMap<Number, Immutable.Record<IUserAddressStore>> = Immutable.OrderedMap<Number, Immutable.Record<IUserAddressStore>>(), action: AccountAction | AjaxActionStart | AjaxActionEnd):Immutable.OrderedMap<Number, Immutable.Record<IUserAddressStore>> => {
	let loading = false;
	switch (action.type) {
		case AccountActionType.AddUserAddresses :
		case AccountActionType.EditUserAddresses :
			store = store.withMutations(store => {
				for(let address in action.addresses) {
					if(!action.addresses.hasOwnProperty(address)) continue;
					let a = action.addresses[address];
					a.loading = a.loading || false;
					store.set(a.id, Immutable.fromJS(a));
				}
			})
		break;

		case AccountActionType.RemoveUserAddress :
			store = store.setIn([Number(action.id), 'deleted'], true);
			break;

		case AjaxActionStartType :
			if(action.url == 'ajax/user/addresses/delete-user-address') {
				store = store.setIn([Number(action.data.get('id')), 'loading'], true);
			}
		break;

		case AjaxActionEndType :
			if(action.url == 'ajax/user/addresses/delete-user-address') {
				if(!store.get(action.data.get('id'))) break;
				store = store.setIn([Number(action.data.get('id')), 'loading'], false);
			}
		break;
	}
	return store;
}

export default UserAddressesReducer